import { useState, useEffect } from 'react';
import { checkSubscriptionStatus } from '../util/subscriptionUtils';

/**
 * 구독 상태를 확인하여 접근 권한 정보를 반환한다.
 *
 * @param {object|null} session - Supabase 세션 객체
 * @returns {{ loading: boolean, hasAccess: boolean, subscription: object|null, freeTrialInfo: object|null }}
 */
export function useSubscriptionAccess(session) {
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);
  const [subscription, setSubscription] = useState(null);
  const [freeTrialInfo, setFreeTrialInfo] = useState(null);

  useEffect(() => {
    async function checkStatus() {
      setLoading(true);
      const status = await checkSubscriptionStatus(session);

      setLoading(status.loading);
      setHasAccess(status.hasAccess);
      setSubscription(status.subscription);
      setFreeTrialInfo(status.freeTrialInfo);
    }

    checkStatus();
  }, [session]);

  return { loading, hasAccess, subscription, freeTrialInfo };
}
